// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39del","type":"styles_type__6M7FE","choices":"styles_choices__3F9mP"};